import { defineMessages } from 'react-intl';

export default defineMessages({
    stepCoverables: {
        id: 'quoteandbind.ConsTraAndServProduct.wizard.step.Coverables',
        defaultMessage: 'Coverables',
    },
    questions: {
        id: 'quoteandbind.ConsTraAndServProduct.wizard.step.Questions',
        defaultMessage: 'Questions',
    },
    stepCoverages: {
        id: 'quoteandbind.ConsTraAndServProduct.wizard.step.Coverages',
        defaultMessage: 'Coverages',
    },
    exposures: {
        id: 'quoteandbind.ConsTraAndServProduct.wizard.step.Exposures',
        defaultMessage: 'Exposures',
    },
    // add string ids and default values for localization here
});
